import script from "./TermosDeUso.vue?vue&type=script&setup=true&lang=js"
export * from "./TermosDeUso.vue?vue&type=script&setup=true&lang=js"

import "./TermosDeUso.vue?vue&type=style&index=0&id=8c955962&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c955962"]])

export default __exports__